import React, { useState, useEffect } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

import { getCartDetailsFromCartId, placeOrderForNivaBupa, updateCartItemForNivaBupa } from './UploadRxComponents/Services';
//import {pharmacyOpsActions} from '../../constant';

const GetCartsByMobileNo = ({ onClose, cartId }) => {


    const [cartData, setCartData] = useState(null); 
    const [isLoading , setIsLoading] = useState(false);
    const [disablePlaceOrderButton, setDisablePlaceOrderButton] = useState(false);
    const [orderResponse, setOrderResponse] = useState(null);
    const [userId, setUserId] = useState(null);
    const [addressId, setAddressId] = useState(null);

    useEffect(() => {
        async function getCartDetailsById() {
            setIsLoading(true);
            const cartResponse = await getCartDetailsFromCartId(cartId);
            if (cartResponse && cartResponse.success && cartResponse.cartDetail) {
                setUserId(cartResponse.cartDetail.userId);
                setAddressId(cartResponse.cartDetail.addressId)
                setCartData(cartResponse.cartDetail); 
            }   
             else {
                setCartData(null);
                setIsLoading(false);
            }
        }
        if (cartId) {
            getCartDetailsById();
        }
    }, [cartId]);

    const handlePlaceOrder = async () => {
        if (!cartId) return;
        setDisablePlaceOrderButton(true);
        const res = await placeOrderForNivaBupa(cartId, userId, addressId);
        setOrderResponse(res);
    };

    const handleUpdateCartItem = async (cartItemId, newQuantity) => {
        const res = await updateCartItemForNivaBupa(userId, cartItemId, newQuantity);
        if (res) {
            // Refresh cart details after updating item
            const cartResponse = await getCartDetailsFromCartId(cartId, userId, addressId);
            if (cartResponse && cartResponse.success && cartResponse.cartDetail) {
                setCartData(cartResponse.cartDetail); 
            }
        }
    }


    return (
        <Modal isOpen={true} toggle={onClose}>
            <ModalHeader toggle={onClose}>Place Order For Niva-Bupa S&B</ModalHeader>
            <ModalBody>
                 <h3 style={{ margin: '8px 0', fontSize: '24px', color: '#333' }}>Carts</h3>
                 {cartData?.isRxRequired && (
                    <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: '#d9f7be', // light green
                        border: '1px solid #b7eb8f',
                        padding: '10px 16px',
                        borderRadius: '6px',
                        marginBottom: '16px',
                        color: '#389e0d',
                        fontWeight: 500,
                        fontSize: '14px',
                    }}
                    >
                    <span style={{ marginRight: '8px', fontSize: '18px' }}>⚠️</span>
                    This cart contains medicine(s) which require a valid prescription (Rx)
                    </div>
                )}
                {cartData ? (
                    <>
                        <div className="card-header">
                            <div className="row no-gutters">
                                <div className="col">
                                    <label
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <div
                                            style={{
                                                fontStyle: 'normal',
                                                fontWeight: 700,
                                                fontSize: '16px',
                                                lineHeight: '130%',
                                                letterSpacing: '0.25px',
                                                textAlign: 'left',
                                                textTransform: 'capitalize',
                                                margin: '0 16px',
                                            }}
                                        >
                                            Partner : TATA 1mg
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="card-body">
                            <ul className="list-group list-group-flush">
                                {cartData.cartItems.length == 0 ? 'Cart does not contain any items': cartData.cartItems.map((med) => (
                                    <li
                                        key={med.cartItemId}
                                        className="list-group-item"
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',   
                                            justifyContent: 'space-between',
                                            padding: '12px 16px',
                                            borderBottom: '1px solid #e0e0e0',
                                        }}
                                    >
                                        {/* Medicine Name */}
                                        <div
                                            style={{
                                                flex: 2,
                                                overflow: 'hidden',
                                                whiteSpace: 'nowrap',
                                                textOverflow: 'ellipsis',
                                                fontWeight: 500,
                                                fontSize: '16px',
                                                color: '#333',
                                            }}
                                            title={med.brandName}
                                        >
                                            {med.brandName}
                                        </div>

                                        {/* Quantity Controls */}
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                flex: 1,
                                                justifyContent: 'center',
                                            }}
                                        >
                                            {med.quantity === med.minQuantity ? (
                                                <button
                                                    style={{
                                                        border: 'none',
                                                        background: 'transparent',
                                                        color: '#ff4d4f',
                                                        fontSize: '20px',
                                                        cursor: 'pointer',
                                                        marginRight: '8px',
                                                    }}
                                                    onClick={() => handleUpdateCartItem(med.cartItemId, 0)}
                                                    title="Remove Item"
                                                >
                                                    🗑️
                                                </button>
                                            ) : (
                                                <button
                                                    style={{
                                                        padding: '4px 12px',
                                                        border: '1px solid #d9d9d9',
                                                        borderRadius: '4px',
                                                        background: '#f5f5f5',
                                                        cursor: 'pointer',
                                                        marginRight: '8px',
                                                        fontSize: '16px',
                                                    }}
                                                    onClick={() => handleUpdateCartItem(med.cartItemId, med.quantity - 1)}
                                                >
                                                    -
                                                </button>
                                            )}

                                            <span
                                                style={{
                                                    minWidth: '36px',
                                                    textAlign: 'center',
                                                    padding: '6px 8px',
                                                    border: '1px solid #d9d9d9',
                                                    borderRadius: '4px',
                                                    fontSize: '16px',
                                                    background: '#fafafa',
                                                    color: '#333',
                                                }}
                                            >
                                                {med.quantity}
                                            </span>

                                            <button
                                                style={{
                                                    padding: '4px 12px',
                                                    border: '1px solid #d9d9d9',
                                                    borderRadius: '4px',
                                                    background: '#f5f5f5',
                                                    cursor: 'pointer',
                                                    marginLeft: '8px',
                                                    fontSize: '16px',
                                                    color: '#333',
                                                }}
                                                onClick={() => handleUpdateCartItem(med.cartItemId, med.quantity + 1)}
                                            >
                                                +
                                            </button>
                                        </div>

                                        {/* Price */}
                                        <div
                                            style={{
                                                flex: 0.8,
                                                textAlign: 'right',
                                                fontWeight: 500,
                                                fontSize: '16px',
                                                color: '#333',
                                            }}
                                        >
                                            ₹{med.mrp}
                                        </div>
                                    </li>
                                ))}
                            </ul>



                        </div>

                        <div className="card-footer">
                            <ul className="list-group list-group-flush">
                                <li
                                    className="list-group-item"
                                    style={{ display: 'flex', justifyContent: 'space-between' }}
                                >
                                    <div>Subtotal Amount</div>
                                    <div>₹{cartData.subTotalAmount}</div>
                                </li>
                                <li
                                    className="list-group-item"
                                    style={{ display: 'flex', justifyContent: 'space-between' }}
                                >
                                    <div>Visit Discount</div>
                                    <div>- ₹{cartData.totalDiscount}</div>
                                </li>
                                <li
                                    className="list-group-item"
                                    style={{ display: 'flex', justifyContent: 'space-between' }}
                                >
                                    <div>Total Amount</div>
                                    <div>₹{cartData.totalAmount}</div>
                                </li>
                                <li
                                    className="list-group-item"
                                    style={{ display: 'flex', justifyContent: 'space-between' }}
                                >
                                    <div>Order Type</div>
                                    <div>COD</div>
                                </li>
                                <li
                                    className="list-group-item"
                                    style={{ display: 'flex', justifyContent: 'space-between' }}
                                >
                                    <div>Delivery Charges</div>
                                    <div>₹{cartData.deliveryCharge}</div>
                                </li>
                                <li
                                    className="list-group-item"
                                    style={{ display: 'flex', justifyContent: 'space-between' }}
                                >
                                    <div>User Payable</div>
                                    <div>₹{cartData.userPayable}</div>
                                </li>
                                <li
                                    className="list-group-item"
                                    style={{ display: 'flex', justifyContent: 'space-between' }}
                                >
                                    <div>Wallet Discount</div>
                                    <div>₹{cartData.walletDiscount || 0}</div>
                                </li>
                            </ul>
                        </div>

                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <button
                                onClick={handlePlaceOrder}
                                disabled={disablePlaceOrderButton}
                                class = "btn btn-primary"
                                type = "button"
                            >
                                Place Order
                            </button>
                        </div>
                    </>
                ) : (
                    isLoading ? <p>Loading cart details...</p> : <p>No cart available.</p>
                )}

                {orderResponse && (
                    <div style={{ marginTop: '20px', color: '#0f4a11' }}>
                        <p><strong>Order Status:</strong> {orderResponse.message}</p>
                        <p><strong>Order Id:</strong> {orderResponse.orderId}</p>
                    </div>
                )}
            </ModalBody>
        </Modal>
    );
}

export default GetCartsByMobileNo;
